export class CreditFilter {
    id: number = 0;
    frontOffice: string = "";
    bank: string = "";
    negRef: string[] = []
    startForecast: string = "";
    endForecast: string = "";
    startRelease: string = "";
    endRelease: string = "";
}
